import React, { useEffect, useState } from 'react'
import { PlusCircleOutlined } from '@ant-design/icons'
import { Button, Flex, Radio, RadioChangeEvent } from 'antd'
import './RelativeCard.scss'
import { ICustomerDetail_V2, ICustomerDetail_V4 } from '../../api/customer/customerApi'
import { dataGender } from '../../services/data'
import useToast from '../../hook/useToast'
import { IRelationshipADD } from "../../pages/Customers/Modal/AddRelativeAddCustomer";
import ModalDeleteManager from "../../components/ModalDeleteManager";
import AddRelativeModal from '../../pages/Customers/Modal/PoolingAddRelative'
import UpdateRelative from '../../pages/Customers/Modal/PoolingAddRelativeUpdate'
import * as relativesApi from '../../api/relatives/relativesApi'
import RelativeCollapse from './PoolingRelativeCollapse'
import { deleteBusiness, getInfoBusiness, IBusiness } from '../../api/business/businessApi'
import BusinessCollapse from './PoolingBusinessCollapse'
import AddBusiness from '../../pages/Customers/Modal/PoolingAddBusiness'
import UpdateBusiness from '../../pages/Customers/Modal/PoolingUpdateBusiness'
interface Props {
  title: string
  infoCustomer?: ICustomerDetail_V4;
  listRelativeCustomer: relativesApi.IRelationship_V2[]
  listBusinessCustomer?: IBusiness[]
  resultSubmitFormModalAddRelative?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalUpdateRelative?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalDeleteRelative?: (iSsuccess: boolean, message?: string) => void

  resultSubmitFormModalAddBusiness?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalUpdateBusiness?: (iSsuccess: boolean, message?: string) => void
  resultSubmitFormModalDeleteBusiness?: (iSsuccess: boolean, message?: string) => void
  nguoiLienHe?: any
}

const RelativeCard: React.FC<Props> = ({
  title, infoCustomer, listRelativeCustomer, listBusinessCustomer,
  resultSubmitFormModalAddRelative, resultSubmitFormModalUpdateRelative, resultSubmitFormModalDeleteRelative,
  resultSubmitFormModalAddBusiness, resultSubmitFormModalUpdateBusiness, resultSubmitFormModalDeleteBusiness,
  nguoiLienHe
}) => {
  const pushToast = useToast();


  const [openIndex, setOpenIndex] = useState<any>()

  const [sampleListRelativeCustomer, setSampleListRelativeCustomer] = useState<relativesApi.IRelationship_V2[]>([])

  const sampleListBusinessCustomer: IBusiness[] = [
    // {
    //   id: 1,
    //   businessName: "Công ty TNHH ABC",
    //   businessRelationship: { id: 1, title: "Khách hàng" },
    //   phoneBusiness: "02812345678",
    //   foundingDate: "2010-05-20",
    //   address: "789 Đường DEF",
    //   district: { id: 1, title: "Quận 5" },
    //   province: { id: 1, title: "TP.HCM" },
    //   email: "contact@abc.com",
    //   businessField: { id: 1, title: "Công nghệ thông tin" },
    //   taxCode: "0301234567",
    // },
  ]
  useEffect(() => {
    const temp = [] as any
    nguoiLienHe.map((val: any) => {
      if(val.unknown_field_44 !== null) {
        temp.push({
          id: val.id,
          username: val.unknown_field_44,
          relativeTitle: "",
          gender: val.address,
          phone: val.birthday,
          birthday: val.unknown_field_29,
          address: val.unknown_field_9,
          districtTitle: val.phone,
          provinceTitle: val.unknown_field_35,
          email: val.source_channel,
          professionTitle: "",
          CCCD: val.interest,
          professionId: 1,
          provinceId: 1,
          districtId: 1,
          relativeId: 1,
        })
      }
      return true
    })
    setSampleListRelativeCustomer(temp)
  }, [nguoiLienHe])
  // ADD RELATIVE
  const [showAddRelativeModal, setShowAddRelativeModal] = useState(false)
  const [isModalRelativesUpdate, setIsModalRelativesUpdate] = useState(false)
  const [isModalRelativesDelete, setIsModalRelativesDelete] = useState(false)
  //
  const [isModalBusinessAdd, setIsModalBusinessAdd] = useState(false)
  const [isModalBusinessUpdate, setIsModalBusinessUpdate] = useState(false)
  const [isModalBusinessDelete, setIsModalBusinessDelete] = useState(false)

  const [idChoose, setIDChoose] = useState<number>()
  const [infoRelative, setInfoRelative] = useState<relativesApi.IRelationship_V2>()
  const [infoBusiness, setInfoBusiness] = useState<IBusiness>()

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }
  const onSubmitFormModal = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setShowAddRelativeModal(false)
      resultSubmitFormModalAddRelative?.(true, message)
    } else {
      resultSubmitFormModalAddRelative?.(false, message)
    }
  }

  const gInfoRelative = async (id: number) => {
    const result = await relativesApi.getInfoRelativeCustomer(id, Number(infoCustomer?.id))

    if (result?.status) {
      setInfoRelative(result.data)
      setIsModalRelativesUpdate(true)
    } else {
      pushToast(result?.message, "error")
    }
  }

  const onSubmitFormModalUpdateRelative = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalRelativesUpdate(false)
      resultSubmitFormModalUpdateRelative?.(true, message)
    } else {
      resultSubmitFormModalUpdateRelative?.(false, message)
    }
  }

  const openModalDelete = (id: number) => {
    setIDChoose(id)
    setIsModalRelativesDelete(true)
  }

  const onConfirmDelete = async () => {
    closeModalDeleter()
    return
    const result = await relativesApi.deleteRelativeCustomer(Number(idChoose))
    if (result?.status) {
      resultSubmitFormModalDeleteRelative?.(true, result?.message)
    } else {
      resultSubmitFormModalDeleteRelative?.(false, result?.message)
    }
    closeModalDeleter()
  }

  const closeModalDeleter = () => {
    setIDChoose(undefined)
    setIsModalRelativesDelete(false)
  }


  //DN
  const onSubmitFormModalAddBusiness = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalBusinessAdd(false)
      resultSubmitFormModalAddBusiness?.(true, message)
    } else {
      resultSubmitFormModalAddBusiness?.(false, message)
    }
  }

  const gInfoBusiness = async (id: number) => {
    setIsModalBusinessUpdate(true)
    return
    const result = await getInfoBusiness(id)
    if (result?.status) {
      setInfoBusiness(result.data)
      setIsModalBusinessUpdate(true)
    } else {
      pushToast(result?.message, "error")
    }
  }

  const onSubmitFormModalUpdateBusiness = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalBusinessUpdate(false)
      resultSubmitFormModalUpdateBusiness?.(true, message)
    } else {
      resultSubmitFormModalUpdateBusiness?.(false, message)
    }
  }

  const openModalDeleteBusiness = (id: number) => {
    setIDChoose(id)
    setIsModalBusinessDelete(true)
  }

  const onConfirmDeleteBusiness = async () => {
    closeModalDeleterBusiness()
    return
    const result = await deleteBusiness(Number(idChoose), Number(infoCustomer?.id))
    if (result?.status) {
      resultSubmitFormModalDeleteBusiness?.(true, result?.message)
    } else {
      resultSubmitFormModalDeleteBusiness?.(false, result?.message)
    }
    closeModalDeleterBusiness()

  }

  const closeModalDeleterBusiness = () => {
    setIDChoose(undefined)
    setIsModalBusinessDelete(false)
  }


  // TYPE CAR RADIO
  const carTypes = [
    { value: 'xe-dang-su-dung', label: 'Thông tin người liên hệ' },
    { value: 'xe-quan-tam', label: 'Thông tin doanh nghiệp' },
  ]
  const [selectedCarType, setSelectedCarType] = useState('xe-dang-su-dung')

  const onChangeCarType = ({ target: { value } }: RadioChangeEvent) => {
    setSelectedCarType(value)
  }


  return (
    <div className="relative-card">
      <AddRelativeModal
        show={showAddRelativeModal}
        infoCustomer={infoCustomer}

        modalClose={() => setShowAddRelativeModal(false)}
        onSuccess={() => setShowAddRelativeModal(false)}
        onSubmitFormModal={onSubmitFormModal}
      />

      <UpdateRelative
        show={isModalRelativesUpdate}
        infoRelative={infoRelative}
        infoCustomer={infoCustomer}

        modalClose={() => setIsModalRelativesUpdate(false)}
        onSubmitFormModal={onSubmitFormModalUpdateRelative}
      />

      <ModalDeleteManager
        isOpen={isModalRelativesDelete}
        title="Bạn có chắc chắn xóa người liên hệ này"
        titleDelete="Xóa người liên hệ"
        content="người liên hệ và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onConfirmDelete}
        closeModal={closeModalDeleter}
      />

      <AddBusiness
        show={isModalBusinessAdd}
        infoCustomer={infoCustomer}

        modalClose={() => setIsModalBusinessAdd(false)}
        onSubmitFormModal={onSubmitFormModalAddBusiness}
      />

      <UpdateBusiness
        show={isModalBusinessUpdate}
        infoCustomer={infoCustomer}
        infoBusiness={infoBusiness}
        modalClose={() => setIsModalBusinessUpdate(false)}
        onSubmitFormModal={onSubmitFormModalUpdateBusiness}
      />

      <ModalDeleteManager
        isOpen={isModalBusinessDelete}
        title="Bạn có chắc chắn xóa doanh nghiệp này"
        titleDelete="Xóa doanh nghiệp"
        content="Doanh nghiệp và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onConfirmDeleteBusiness}
        closeModal={closeModalDeleterBusiness}
      />

      <div className={`order-history-card`}

      >
        <div className="order-history-card__head t-ml-auto"
        // hidden={true}
        >
          <Radio.Group
            value={selectedCarType}
            className='rs-radio-group'
            onChange={onChangeCarType}
          >
            {
              carTypes.map((item: any) => (
                <Radio.Button
                  key={item.value}
                  value={item.value}
                  className='rs-radio'
                >{item.label}</Radio.Button>
              ))
            }
          </Radio.Group>
        </div>

        {
          selectedCarType === 'xe-dang-su-dung' ?
            <div className="title-ds">
              <div className="title">Danh sách người liên hệ</div>

            </div>
            :
            <div className="title-ds">
              <div className="title">Danh sách doanh nghiệp</div>
            </div>
        }

        <Flex vertical className="">
          {
            selectedCarType === 'xe-dang-su-dung' ?
              sampleListRelativeCustomer?.map((item, index) => (
                <RelativeCollapse
                  key={index}
                  show={openIndex === index}
                  showControl={false}

                  id={item.id}
                  title={item.username ?? ""}
                  relationship={item.relativeTitle ?? ""}
                  name={item.username ?? ""}
                  gender={item.gender as any}
                  // phoneNumber={item.phone ?? ""}
                  phoneNumber={Array.isArray(item.phone) ? item.phone.map(p => p.phone).join(", ") : ""}
                  dateOfBirth={item.birthday ?? ""}
                  // address={[item.address, item.districtTitle, item.provinceTitle].filter(Boolean).join("-")}
                  email={item.email}
                  career={item.professionTitle ?? ""}
                  infoCustomer={infoCustomer}
                  onToggle={() => handleToggle(index)}

                  handleOpenModalUpdate={gInfoRelative}
                  handleOpenModalDele={openModalDelete}
                />
              ))
              :
              sampleListBusinessCustomer?.map((item, index) => (
                <BusinessCollapse
                  key={index}
                  show={openIndex === index}
                  showControl={false}

                  index={index}
                  id={item.id}
                  title={item.businessName ?? ""}
                  relationship={item.businessRelationship?.title ?? ""}
                  name={item.businessName ?? ""}
                  // phoneNumber={item.phoneBusiness ?? ""}
                  phoneNumber={Array.isArray(item.phoneBusiness) ? item.phoneBusiness.map(p => p.phone).join(", ") : ""}
                  dateOfBirth={item.foundingDate ?? ""}
                  address={[item?.address, item?.district?.title, item?.province?.title].filter(Boolean).join("-")}
                  email={item.email}
                  career={item.businessField?.title ?? ""}
                  taxCode={item.taxCode ?? ""}
                  infoCustomer={infoCustomer}

                  onToggle={() => handleToggle(index)}

                  handleOpenModalUpdate={gInfoBusiness}
                  handleOpenModalDele={openModalDeleteBusiness}
                />
              ))
          }
        </Flex>
      </div>
    </div>
  )
}

export default RelativeCard
